import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { post } from "../../../utils/sysAxios";
import { Dropdown } from "primereact/dropdown";

const styles = `
.ctm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ctm-modal {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);
  font-family: 'DM Sans', sans-serif;
  overflow: hidden;
}
[dir="rtl"] .ctm-modal,
[dir="rtl"] .ctm-modal *:not(i):not([class*="fa"]):not([class*="pi"]) {
  font-family: 'Cairo', 'DM Sans', sans-serif !important;
}
.ctm-header {
  background: #1A1D23;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 3px solid #3B82F6;
}
.ctm-header-title {
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: -0.02em;
}
.ctm-header-title .accent { color: #60A5FA; }
.ctm-close {
  background: none;
  border: none;
  color: #9CA3AF;
  cursor: pointer;
  font-size: 1rem;
  padding: 4px;
  border-radius: 4px;
  transition: color .15s;
}
.ctm-close:hover { color: #fff; }
.ctm-body {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ctm-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ctm-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: .04em;
}
.ctm-label .req { color: #EF4444; margin-left: 2px; }
.ctm-input, .ctm-textarea {
  width: 100%;
  padding: 9px 12px;
  border: 1.5px solid #E5E9EF;
  border-radius: 8px;
  font-size: 0.875rem;
  font-family: 'DM Sans', sans-serif;
  color: #1A1D23;
  outline: none;
  transition: border-color .15s;
  box-sizing: border-box;
}
.ctm-input:focus, .ctm-textarea:focus { border-color: #3B82F6; }
.ctm-textarea { resize: vertical; min-height: 90px; }
.ctm-modal .p-dropdown {
  width: 100% !important;
  border: 1.5px solid #E5E9EF !important;
  border-radius: 8px !important;
  font-size: 0.875rem !important;
}
.ctm-modal .p-dropdown:focus, .ctm-modal .p-dropdown.p-focus { border-color: #3B82F6 !important; box-shadow: none !important; }
.ctm-footer {
  padding: 14px 20px;
  border-top: 1px solid #F3F4F6;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.ctm-btn {
  padding: 9px 22px;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: 'DM Sans', sans-serif;
  cursor: pointer;
  border: none;
  transition: background .15s, opacity .15s;
}
.ctm-btn:disabled { opacity: .5; cursor: not-allowed; }
.ctm-btn-cancel {
  background: #F3F4F6;
  color: #374151;
  border: 1.5px solid #E5E9EF;
}
.ctm-btn-cancel:hover:not(:disabled) { background: #E5E9EF; }
.ctm-btn-submit {
  background: #3B82F6;
  color: #fff;
}
.ctm-btn-submit:hover:not(:disabled) { background: #2563EB; }
`;

class CreateTicketModal extends Component {
  state = {
    unitId: null,
    ticketTypeId: null,
    title: "",
    body: "",
    unitOptions: [],
    loadingUnits: true,
    submitting: false,
  };

  componentDidMount() {
    post("/api/data/GetAllUnitsOwner", {}, () => {})
      .then((res) => {
        const units = res.data.respData.data || [];
        this.setState({ unitOptions: units, loadingUnits: false });
      })
      .catch(() => this.setState({ loadingUnits: false }));
  }

  handleSubmit = () => {
    const { unitId, ticketTypeId, title, body } = this.state;
    if (!unitId || !ticketTypeId || !title.trim() || !body.trim()) return;

    this.setState({ submitting: true });
    post(
      "/api/data/AddTicket",
      { unitId, ticketTypeId, title: title.trim(), body: body.trim() },
      () => {}
    )
      .then(() => {
        this.setState({ submitting: false });
        this.props.onClose(true);
      })
      .catch(() => this.setState({ submitting: false }));
  };

  render() {
    const { t, onClose, typeOptions } = this.props;
    const { unitId, ticketTypeId, title, body, unitOptions, loadingUnits, submitting } = this.state;

    const canSubmit = unitId && ticketTypeId && title.trim() && body.trim() && !submitting;

    const toOpts = (arr) => arr.map(x => ({ label: x.label, value: x.value }));

    return (
      <div className="ctm-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(false); }}>
        <style>{styles}</style>
        <div className="ctm-modal">
          <div className="ctm-header">
            <div className="ctm-header-title">
              <i className="fa fa-plus-circle" />
              {t("tick.createTicket")}
              <span className="accent">—</span>
              {t("pages.ticketManagement")}
            </div>
            <button className="ctm-close" onClick={() => onClose(false)}>
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="ctm-body">
            {/* Unit */}
            <div className="ctm-field">
              <label className="ctm-label">{t("col.unit")} <span className="req">*</span></label>
              <Dropdown
                value={unitId}
                options={unitOptions}
                onChange={(e) => this.setState({ unitId: e.value })}
                placeholder={loadingUnits ? t("tick.loading") : t("tick.selectUnit")}
                disabled={loadingUnits}
                filter
              />
            </div>

            {/* Ticket Type */}
            <div className="ctm-field">
              <label className="ctm-label">{t("filter.type")} <span className="req">*</span></label>
              <Dropdown
                value={ticketTypeId}
                options={toOpts(typeOptions)}
                onChange={(e) => this.setState({ ticketTypeId: e.value })}
                placeholder={t("tick.selectType")}
                filter
              />
            </div>

            {/* Title */}
            <div className="ctm-field">
              <label className="ctm-label">{t("col.title")} <span className="req">*</span></label>
              <input
                className="ctm-input"
                type="text"
                value={title}
                onChange={(e) => this.setState({ title: e.target.value })}
                placeholder={t("tick.titlePlaceholder")}
                maxLength={200}
              />
            </div>

            {/* Body */}
            <div className="ctm-field">
              <label className="ctm-label">{t("col.body")} <span className="req">*</span></label>
              <textarea
                className="ctm-textarea"
                value={body}
                onChange={(e) => this.setState({ body: e.target.value })}
                placeholder={t("tick.bodyPlaceholder")}
                rows={4}
              />
            </div>
          </div>

          <div className="ctm-footer">
            <button className="ctm-btn ctm-btn-cancel" onClick={() => onClose(false)} disabled={submitting}>
              {t("btn.cancel")}
            </button>
            <button className="ctm-btn ctm-btn-submit" onClick={this.handleSubmit} disabled={!canSubmit}>
              {submitting
                ? <><i className="fa fa-spinner fa-spin" style={{ marginRight: 6 }} />{t("tick.submitting")}</>
                : <><i className="fa fa-check" style={{ marginRight: 6 }} />{t("tick.createTicket")}</>
              }
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CreateTicketModal);
